import { inheritsLoose as _inheritsLoose } from './_virtual/_rollupPluginBabelHelpers.js';
import { createElement, Component } from 'react';

/**
 * Returns a new React component, ready to be instantiated.
 * Note the closure here protecting Component, and providing a unique
 * instance of Component to the static implementation of `load`.
 */

function asyncComponent(_ref) {
  var loader = _ref.loader,
      Placeholder = _ref.Placeholder,
      chunkName = _ref.chunkName;
  // keep Component in a closure to avoid doing this stuff more than once
  var Component$1 = null;
  return /*#__PURE__*/function (_React$Component) {
    _inheritsLoose(AsyncRouteComponent, _React$Component);

    function AsyncRouteComponent() {
      var _this;

      _this = _React$Component.apply(this, arguments) || this;
      _this.state = {
        Component: Component$1
      };

      _this.updateState = function () {
        // Only update state if we don't already have a reference to the
        // component, this prevent unnecessary renders.
        if (_this.state.Component !== Component$1) {
          _this.setState({
            Component: Component$1
          });
        }
      };

      return _this;
    }
    /**
     * Static so that you can call load against an uninstantiated version of
     * this component. This should only be called one time outside of the
     * normal render path.
     */


    AsyncRouteComponent.load = function load() {
      return loader().then(function (ResolvedComponent) {
        Component$1 = ResolvedComponent["default"] || ResolvedComponent;
      });
    };

    AsyncRouteComponent.getChunkName = function getChunkName() {
      return chunkName;
    };

    AsyncRouteComponent.getInitialProps = function getInitialProps(ctx) {
      // Need to call the wrapped components getInitialProps if it exists
      if (Component$1 !== null) {
        return Component$1.getInitialProps ? Component$1.getInitialProps(ctx) : Promise.resolve(null);
      }
    };

    var _proto = AsyncRouteComponent.prototype;

    _proto.componentDidMount = function componentDidMount() {
      AsyncRouteComponent.load().then(this.updateState);
    };

    _proto.render = function render() {
      var ComponentFromState = this.state.Component;

      if (ComponentFromState) {
        return createElement(ComponentFromState, Object.assign({}, this.props));
      }

      if (Placeholder) {
        return createElement(Placeholder, Object.assign({}, this.props));
      }

      return null;
    };

    return AsyncRouteComponent;
  }(Component);
}

export { asyncComponent };
//# sourceMappingURL=asyncComponent.esm.js.map
